<template>
  <div>
    <section class="hero hero-image hero-lu is-fullheight">
      <div class="hero-head">
        <Header/>
      </div>
      <div class="hero-content">
        <div class="columns">
          <div class="column is-5">
            <div class="hero-box box has-text-centered">
              <h1 class="title is-size-4-touch is-size-1-desktop">
                Yiqing Zhou<br/>
                <span class="title-ch is-size-4-touch is-size-2-desktop">
                  周伊青
                </span>
              </h1>
              <h3 class="subtitle is-5-desktop is-size-6-touch">
                November 9, 1958 to April 16, 2020
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-footer">
      </div>
    </section>
    <section class="section section-story">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-two-thirds">
            <StorySection v-for="(section, index) in aboutSections"
                          :key="index"
                          v-bind:section=section />
          </div>
          <div class="column is one-third">
            <div class="img-container is-hidden-mobile" v-prlx="prlxOpts">
              <img v-for="(src, index) in aboutImages"
                   :key="index"
                   alt="section.sname" :src="src"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section hero hero-balloons is-medium is-hidden-mobile"
             v-prlx.background="imgPrlxOpts">
    </section>
    <section class="section has-text-centered">
      <h1 class="title is-2">We love you, Mom.</h1>
    </section>
  </div>
</template>

<style lang="scss">
@import "@/assets/vars.scss";

.hero {
  .navbar, .navbar-menu {
    background-color: transparent;
  }
  .navbar-item {
    color: $invert-navbar-link;
  }
  .navbar-item:hover {
    color: $blue-med;
  }
  .navbar-burger {
    color: $dark-navbar-link;
    background-color: $dark;
  }

  .hero-content {
    .hero-box {
      margin: 0 2em;
      padding: 2em;
      width: auto;
      background-color: rgba(18, 23, 41, 0.6);
      border-color: rgba(18, 23, 41, 0.6);
      border-radius: 4px;
    }

    .title{
      font-weight: normal;
      margin-bottom: 1em;
    }

    .subtitle {
      margin-bottom: 1em;
    }
  }
}

.hero-image {
  background-position: center center;
  background-repeat:  no-repeat;
  background-size: cover;
}

.hero-lu {
  background-position: center right;
  background-image: linear-gradient(to right,
    rgba(18, 23, 41, 0.4), rgba(18, 23, 41, 0.2)),
   url('../assets/images/herolu.jpg');
  // background-image: url('../assets/images/herolu.jpg');
}

.hero-balloons {
  background-image: linear-gradient(to right,
    rgba(18, 23, 41, 0.4), rgba(18, 23, 41, 0.0), rgba(18, 23, 41, 0.4)),
    url('../assets/images/heroballoons.jpg');
}

</style>

<script>
import aboutText from '@/about.json';
import Header from '@/components/Header.vue';
import StorySection from '@/components/StorySection.vue';

export default {
  name: 'About',
  components: {
    Header,
    StorySection,
  },
  data() {
    return {
      aboutSections: aboutText.sections,
      aboutImages: aboutText.images,
      imgPrlxOpts: {
        fromBottom: true,
        speed: 0.07,
        limit: {
          // min: -50,
          // max: 50,
        },
      },
      ballonPrlxOpts: {
        speed: 0.09,
        fromBottom: true,
        limit: { min: 0, max: 50 },
      },
    };
  },
};
</script>
